// Our brands - logo slider
// Uses the Flickity + jQuery already loaded globally in theme.liquid.
(function () {
  function initSlider(el) {
    if (!el || el.classList.contains('flickity-enabled')) return;
    if (typeof jQuery === 'undefined' || typeof Flickity === 'undefined') return;

    jQuery(el).flickity({
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      autoPlay: 3000,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true
    });

    var flkty = Flickity.data(el);
    if (!flkty) return;

    // Flickity can leave autoPlay stalled after the slider is dragged/hovered
    // instead of resuming on its own - force it back on once the interaction ends.
    flkty.on('pointerUp', function () {
      flkty.playPlayer();
    });
    el.addEventListener('mouseleave', function () {
      flkty.playPlayer();
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll ? root.querySelectorAll('.ob-logos') : [];
    for (var i = 0; i < sliders.length; i++) {
      initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init when a merchant adds/edits this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
